import { styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const SubmitModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  @media (max-width: 768px) {
    align-items: flex-start;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  width: 80px;
  height: 80px;
  justify-content: center;
  align-items: center;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  @media (max-width: 768px) {
    align-items: flex-start;
  }
`;

export const HeadingText = styled(Text)`
  color: #040222;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.1px;
  @media (max-width: 768px) {
    text-align: left;
  }
`;

export const ThanksText = styled(Text)`
  color: #5b5675;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  @media (max-width: 768px) {
    text-align: left;
  }
`;

export const Errortext = styled.div`
  color: #d83d37;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
`;

export const ErrorContainer = styled.div`
  margin: -1.5rem 0 -1rem 0;
`